import {prop} from 'ramda';

import {DashboardTileSize} from '../types/DashboardTileSize';
import {DASHBOARD_GRID_COLUMNS} from './allocateDashboardGrid';
import {DASHBOARD_TILE_SIZES} from './dashboardTileSizes';

export const isDashboardTileFullWidth = (size: DashboardTileSize) =>
  prop(size, DASHBOARD_TILE_SIZES).columns === DASHBOARD_GRID_COLUMNS;
